function scrollTo(offset, smooth) {
  const nav = document.querySelector('nav.navbar:not(.fixed)')

  if (nav) {
    offset -= nav.getBoundingClientRect().height
  }

  window.scroll({
    top: offset,
    behavior: smooth ? 'smooth' : 'auto'
  })
}

export default function scrollToElement(el, smooth = true) {
  const searchElement = typeof el === 'string' ? (el !== '' ? document.querySelector(el) : null) : el

  if (!searchElement) {
    return
  }

  const top = searchElement.getBoundingClientRect().top + window.scrollY

  scrollTo(top < 0 ? 0 : top, smooth)
}